define('views/blocks/CrossSellingView',['hooks','underscore','jquery', 'backbone', 'router', 'app', 'SubView',
    'TagCommander',
    'views/blocks/ConsumableOptionsView',
    'views/blocks/SidedishView',
    'template!blocks/cross-selling',
	],

    function (hooks, _, $, Backbone, router, app, SubView,
        TagCommander,
        ConsumableOptionsView,
        SidedishView,
        crossSellingTemplate
        ) {

        var CrossSellingView = Backbone.View.extend(SubView).extend({

            initialize: function () {

                var view = this;
                view.subviews = [];
                view.render();
                view.slideSideSelector();
                view.setTrueVh();
            },
            setTrueVh: function() {
                var vh = $(window).height() * 0.01;
                $(document.documentElement).get(0).style.setProperty('--vh', vh + 'px');
            },
            closestIndex: function(num, arr) {
                var curr = arr[0]
                ,   diff = Math.abs(num - curr)
                ,   index = 0

                for (var val = 0; val < arr.length; val++) {
                    var newdiff = Math.abs(num - arr[val])
                    if (newdiff < diff) {
                        diff = newdiff
                        curr = arr[val]
                        index = val
                    }
                }
                return index
            },
            slideSideSelector: function () {
                var view = this
                ,   container = view.$('.sidedish-selling')
                ,   groups = view.$('.sidedish-selling__group')
                ,   tabButtons = view.$('.sidedish__main-title')
                ,   titles = view.$('.sidedish-titles')

                var currentGroup = 0

                setTimeout(function(){
                    var offsetLeft = container.offset().left;
                    tabButtons.each(function(i,el){
                        $(el).data('x',el.getBoundingClientRect().x-offsetLeft)
                    });
                    groups.each(function(i,el){
                        $(el).data('x',el.getBoundingClientRect().x-offsetLeft)
                    });
                },500)

                var debounceScrollId;
                function debounceScroll(scrollItem){
                    if(debounceScrollId) clearTimeout(debounceScrollId);
                    debounceScrollId = setTimeout(function(){
                        debounceScrollId = false;
                        scrollToGroup(currentGroup,true,scrollItem,true);
                    },1000);
                }

                function scrollToGroup(groupIndex,scrollTab,scrollItem,ignoreDebounce){
                    var currentTabButton = tabButtons.eq(groupIndex);
                    tabButtons.not(':eq('+groupIndex+')').removeClass('active')
                    currentTabButton.addClass('active');
                    currentGroup = groupIndex;
                    if(!debounceScrollId || ignoreDebounce){
                        if(!ignoreDebounce) debounceScroll(scrollItem);
                        if(scrollTab){
                            var x = currentTabButton.data('x') || 0;
                            titles.get(0).scrollTo({left:x,behavior:'smooth'})
                        }
                        if(scrollItem){
                            var groupX = groups.eq(groupIndex).data('x') || 0;
                            container.get(0).scrollTo({left:groupX,behavior: 'smooth'})
                        }
                    }
                }

                // clients
                tabButtons.click(function(e){
                    var index = $(e.currentTarget).index()
                    scrollToGroup(index,true, true);
                })

                // scroll mobile sur les onglets
                titles.scroll(function(e){
                    tabButtons.each(function (index, tabButton) {
                        if (Math.round(tabButton.getBoundingClientRect().x) === 0) {
                            scrollToGroup(index,false, app.isMobile())
                        }
                    })
                });

                // scroll mobile sur les items
                container.scroll(function(e){
                    var targetIndex = false;
                    var offsetLeft = container.offset().left;
                    groups.each(function (index, group) {
                        var rect = group.getBoundingClientRect();
                        if (targetIndex === false && rect.left <= offsetLeft && rect.right >= offsetLeft) {
                            targetIndex = index
                        }
                    })
                    if (!debounceScrollId && targetIndex !== false) {
                        scrollToGroup(targetIndex, !debounceScrollId, false)
                    }
                });

            },
            close: function () {
                this.trigger('close', this);
            },
            render: function () {

                var view = this;

                view.$el.html(crossSellingTemplate({

                }));

                view.appendView(ConsumableOptionsView,'.cross-selling__consumable',{theme:'default'});
                view.appendView(SidedishView,'.cross-selling__sidedish',{theme:'default'});

                view.delegateEvents();

            },

        });

        return CrossSellingView;

    });
